import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray,ValidationErrors } from '@angular/forms';
import { UserService } from '../user.service';
import {  Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";  
import { HelperService } from '../helper.service';

@Component({
  selector: 'app-add-company-stores',
  templateUrl: './add-company-stores.component.html',
  styleUrls: ['./add-company-stores.component.css']
})
export class AddCompanyStoresComponent implements OnInit {

  constructor(private fb: FormBuilder, private userService: UserService, private router: Router, private SpinnerService: NgxSpinnerService ) { 
    this.userService.getCompanyAndStores().subscribe((data: any) => {
      //console.log(data.companies.length);
      if (data.companies.length > 0) {
        this.router.navigate(['/company-store']);
      }
    });

  }
  defaultColor = '#0f09ca';
  stateLoading = false;
  stateLoadingStore = [];
  colorBlank : string = '';
  successMessage = HelperService.successMessage;
  CompanyForm: FormGroup;
  StoreForm: FormGroup;
  isValidFormSubmitted = null;
  submitted = null;
  Stores: FormArray;
  states = [];
  States = [];
  countries = [];
  color: '';
  valueofItem = 0;
  timezones = [];
  ngOnInit(): void { 
    this.colorBlank='';
    this.SpinnerService.show();  
    /* if (localStorage.getItem('unllotesLinces') == 'yes') {
      this.router.navigate(['/allot-licences'])
    } */
    this.userService.getcountries().subscribe((data: any) => {
      this.countries = data.countries;
      this.SpinnerService.hide();
    });
    this.userService.gettimezones().subscribe((data: any) => {
      this.timezones = data;
    });
    this.CompanyForm = this.fb.group({
      company_name: ['', Validators.required],
      owner_name: ['', Validators.required],
      contact_number: ['', [Validators.required, Validators.minLength(5)]],
      email_Address: ['', [Validators.required, Validators.email]],
      address_line1: ['', Validators.required],
      address_line2: [''],
      country: ['', Validators.required],
      city: ['', Validators.required],
      State: ['', Validators.required],
      zip: ['', Validators.required],
      Stores: this.fb.array(
        [this.ManageStores()],
        [Validators.required]
      )
    });

  }
  ManageStores(): FormGroup {
    return this.fb.group({
      Storeimage: [null],
      store_name: [null, Validators.required],
      owner_name: [null, Validators.required],
      contact_number: [null, [Validators.required, Validators.minLength(5)]],
      email_Address: [null, Validators.required],
      address_line1: [null, Validators.required],
      country: ['', Validators.required],
      address_line2: [null],
      city: [null, Validators.required],
      State: ['', Validators.required],
      zip: [null, Validators.required],
      primary_color: [null],
      timezone: ['', Validators.required],
    });
  }

  // convenience getter for easy access to form fields 
  get f() { 
    Object.keys(this.CompanyForm.controls).forEach(key => {

      const controlErrors: ValidationErrors = this.CompanyForm.get(key).errors;
      if (controlErrors != null) {
            Object.keys(controlErrors).forEach(keyError => {
              //console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            });
          }
        });
      
    return this.CompanyForm.controls; 
  }

  selectImage(event, i) {
    let file = event.target.files[0];
    this.valueofItem = i
    // File Preview
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.CompanyForm['controls']['Stores']['controls'][this.valueofItem]['controls'].Storeimage.patchValue(e.target.result);
    }
    reader.readAsDataURL(file)

  }
  
  Submit() {
    this.SpinnerService.show();
    this.isValidFormSubmitted = false;
    this.submitted = true;
    ////console.log(this.CompanyForm);
    // stop here if form is invalid
    if (this.CompanyForm.invalid) {
      this.SpinnerService.hide();
      return;
    }

    this.isValidFormSubmitted = true;
    ////console.log(this.CompanyForm.value);
    //return false; 
    this.userService.CreateCompanyAndStores(this.CompanyForm.value,).subscribe(res => {
      if (res.status == 1) {
        this.userService.UserPurchasedProducts().subscribe((result) => {
          if(result.purchased_products.length > 0){
            //this.router.navigate(['/allot-license']);
            this.router.navigate(['/allot-license'])
            .then(() => {
              window.location.reload();
            });
          }
        });
        this.router.navigate(['/company-store']);
      }
      else{
        this.SpinnerService.hide();
      }

    })

  }

  addNewRow() {
    this.StoreArray.push(this.ManageStores());
    ////console.log(this.StoreArray);
  }

  get StoreArray(): FormArray {
    return <FormArray>this.CompanyForm.get('Stores'); 
  }

  changeState(event) {
    this.stateLoading = true;
    localStorage.setItem('country.id', event);
    this.userService.getRegions(event).subscribe(res => {
      this.states = res.regions;
      this.stateLoading = false;
    })
    this.CompanyForm.controls.State.patchValue("");

  }

  changeStateStore(event, i) {
    this.stateLoadingStore[i] = true;
    localStorage.setItem('country.id', event);
    this.userService.getRegions(event).subscribe(res => {
      this.stateLoadingStore[i] = false;
      this.States[i] = res.regions;
    })
    this.CompanyForm['controls']['Stores']['controls'][this.valueofItem]['controls'].State.patchValue("");

  }
  colorPicker(event,i){
    //console.log(event);
    //console.log(i);
    (<HTMLInputElement>document.getElementById("cstm_color_picker"+i)).value = event;
    return false;
  }
  handleChangeComplete(event,index){
    //console.log(this.ManageStores[index]);
    //this.StoreArray[index]['primary_color'] = event;
    //console.log(this.CompanyForm['controls']['Stores']['controls'][index]['controls']);
    (<HTMLInputElement>document.getElementById("cstm_color_picker"+index)).value = event;
    (<HTMLInputElement>document.getElementById("cstm_color_picker"+index)).style.color = event;
    (<HTMLInputElement>document.getElementById("cstm_color_picker"+index)).style.background = event;
   // this.StoreArray.get('primary_color').at(index).value('test');
    this.CompanyForm['controls']['Stores']['controls'][index]['controls'].primary_color.setValue(event);
     //this.CompanyForm['controls']['Stores']['controls'][index]['controls'].primary_color.patchValue(event);
     /* //console.log(this.CompanyForm['controls']['Stores']['controls'][index]);
     //console.log(event);  */
  }  
  
  removeRow(i:number) {
    this.StoreArray.removeAt(i);
    const storeFormData = this.CompanyForm['controls']['Stores']['controls'];
    /* if(storeFormData.length === 0){
      this.ShowForm = false;
    } */
  }
  
}
